/**
 * This is required to ensure IE11+ can work on this webapp,
 * emulating a full ES2015+ environment
 */
import 'isomorphic-fetch'

import React, { Component } from 'react'
import { Auth } from 'aws-amplify'
import ForgotPasswordPanel from '../components/ForgotPasswordPanel'

const INITIAL_STATE = {
  isLoading: false,
  code: '',
  isCodeSent: false,
  newPassword: '',
  newPasswordRepeat: '',
  email: ''
}

const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const REGEX_PASSWORD = /^(?=.*[A-Z])(?=.*[!@#$])(?=.*\d{4,})(?=.*[a-zA-Z]{3,}).{8,}$/;

export default class ForgotPasswordContainer extends Component {

  state = INITIAL_STATE

  validatePanelEmail = () => {
    return REGEX_EMAIL.test(this.state.email)
  }

  validatePanelCode = () => {
    return this.state.code.length > 0 && this.validatePanelEmail()
  }

  validatePassword = () => {
    return this.validatePanelCode() && REGEX_PASSWORD.test(this.state.newPassword)
  }

  validatePasswordEquals = () => {
    return this.state.newPassword === this.state.newPasswordRepeat
  }

  handleChange = event => this.setState({ [event.target.id]: event.target.value })

  handleCode = async () => {
    this.setState({ isLoading: true })
    try {
      await Auth.forgotPassword(this.state.email);
      this.setState({ isLoading: false })
      alert('Um código foi enviado para seu email.')
    } catch (e) {
      if (e.code === 'NotAuthorizedException') {
        alert('Senha inválida!')
      } else if(e.code === 'InvalidPasswordException') {
        if(e.includes('Password not long enoughat')) {
          alert('A senha precisa ter no mínimo 6 caracteres')        
        } else {
          alert(e);
        }
      } else if(e.code === 'LimitExceededException') {
        alert('O limite de pedidos de código foi excedido, tente novamente mais tarde')        
      } else if(e.code === 'UserNotFoundException') {
        alert('Usuário não cadastrado!')
      } else if(e.code === 'CodeMismatchException') {
        alert('O código informado não é válido!')        
      } else if(e.code === 'UserNotConfirmedException') {
          alert('Por favor confirme o código recebido no email antes.')
      } else if(e.code === 'ExpiredCodeException') {
          alert('Código fornecido é inválido.')          
      } else {
        alert('Erro inesperado! Contate o Administrador.')
        console.error('erro', e.code)
        console.error('erro', e)
      }
      this.setState({ isLoading: false })
    }    
  }; 

  handleSubmit = async event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    try {
        //await new Promise( res => setTimeout(res, 5000) );
      await Auth.forgotPasswordSubmit(this.state.email, this.state.code, this.state.newPassword);
      this.props.history.push("/login")  
      this.setState({ isLoading: false })
      alert('Senha alterada com sucesso!')      
    } catch (e) {
      if (e.code === 'NotAuthorizedException') {
        alert('Senha inválida!')
      } else if(e.code === 'InvalidPasswordException') {
        if(e.includes('Password not long enoughat')) {
          alert('A senha precisa ter no mínimo 6 caracteres')        
        } else {
          alert(e);
        }
      } else if(e.code === 'LimitExceededException') {
        alert('O limite de pedidos de código foi excedido, tente novamente mais tarde')        
      } else if(e.code === 'UserNotFoundException') {
        alert('Usuário não cadastrado!')
      } else if(e.code === 'CodeMismatchException') {
        alert('O código informado não é válido!')        
      } else if(e.code === 'UserNotConfirmedException') {
          alert('Por favor confirme o código recebido no email antes.')
      } else if(e.code === 'ExpiredCodeException') {
          alert('Código fornecido é inválido.')          
      } else {
        alert('Erro inesperado! Contate o Administrador.')
        console.error('erro', e.code)
        console.error('erro', e)
      }
      this.setState({ isLoading: false })
    }
  }

  render() {
    return (
      <ForgotPasswordPanel
        email={this.state.email}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleCode={this.handleCode}
        validatePanelEmail={this.validatePanelEmail}
        validatePanelCode={this.validatePanelCode}      
        validatePassword={this.validatePassword}
        validatePasswordEquals={this.validatePasswordEquals}
        isLoading={this.state.isLoading}
        isCodeSent={this.state.isCodeSent}        
        code={this.state.code}
        newPassword={this.state.newPassword}
        newPasswordRepeat={this.state.newPasswordRepeat}
        />
    )
  }
}

